import { render, staticRenderFns } from "./VoteInfoDialog.vue?vue&type=template&id=54841158&scoped=true"
import script from "./VoteInfoDialog.vue?vue&type=script&lang=js"
export * from "./VoteInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./VoteInfoDialog.vue?vue&type=style&index=0&id=54841158&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54841158",
  null
  
)

export default component.exports